import { useSuspenseQuery } from '@tanstack/react-query';
import { useFilterContext } from '../state';
import { appQueries } from '../../api/app.api';
import { WithKeyId } from './types';
import { useCallback } from 'react';
import { IdentityTaskStatus, isTaskFor } from '../../api/app.types';

export default function useIsVisibleCredential() {
  const { hideClosedTasks } = useFilterContext();
  const { data: tasks } = useSuspenseQuery(appQueries.getTasks);

  return useCallback(
    (credential: WithKeyId, appObjectId: string | null | undefined) => {
      if (!hideClosedTasks) return true;

      const task = tasks.find((task) => isTaskFor(task, credential.keyId, appObjectId));
      if (!task) return true;

      return task.status !== IdentityTaskStatus.Done;
    },
    [hideClosedTasks, tasks]
  );
}
